module.exports = __webpack_public_path__ + "img/poster_txt_gq.771ceb47.png";